import Vue from 'vue'
import Vuex from 'vuex'

// Core Modules
import app from './modules/app'
import sms from './modules/sms'
import webrtc from './modules/webrtc'
import appConfig from './modules/app-config'
import verticalMenu from './modules/vertical-menu'
import notifications from './modules/notifications'

// App Modules
import auth from "./modules/auth"
import navigation from "./modules/navigation"

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    sms,
    auth,
    webrtc,
    appConfig,
    navigation,
    verticalMenu,
    notifications,
  },
  strict: process.env.DEV,
})
